import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const CarPayment: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_696)">
                <IconPath
                    d="M18 1.5H21.75C22.1478 1.5 22.5294 1.65804 22.8107 1.93934C23.092 2.22064 23.25 2.60218 23.25 3V15C23.25 16.9891 22.4598 18.8968 21.0533 20.3033C19.6468 21.7098 17.7391 22.5 15.75 22.5H8.25C6.26088 22.5 4.35322 21.7098 2.9467 20.3033C1.54018 18.8968 0.75 16.9891 0.75 15V3C0.75 2.60218 0.908035 2.22064 1.18934 1.93934C1.47064 1.65804 1.85218 1.5 2.25 1.5H6M8.25 12.75H9.75M14.25 12.75H15.75M6.75 15.75V17.25M17.25 15.75V17.25M17.25 9.75L18.5 11.622C18.6629 11.8688 18.7492 12.1583 18.748 12.454V14.254C18.748 14.6518 18.59 15.0334 18.3087 15.3147C18.0274 15.596 17.6459 15.754 17.248 15.754H6.74805C6.35022 15.754 5.96869 15.596 5.68739 15.3147C5.40608 15.0334 5.24805 14.6518 5.24805 14.254V12.454C5.24808 12.1579 5.33576 11.8684 5.50005 11.622L6.75005 9.75M17.25 9.75L16.092 6.276C15.9926 5.97727 15.8016 5.71743 15.5462 5.53328C15.2908 5.34914 14.9839 5.25003 14.669 5.25H9.33105C9.01619 5.25003 8.70932 5.34914 8.45392 5.53328C8.19852 5.71743 8.00754 5.97727 7.90805 6.276L6.75005 9.75M17.25 9.75H6.75005"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_696">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
